<template>
<div class="accountExtract ">

     <div class="status" v-if="showEndPage">
        <img src="../assets/processing.png" alt="" width="27%">
    </div>

     <div class="status" v-if="orderInfo.trade_status == '1'">
         <p>银行处理中</p>
    </div>

    <p class="hint" v-if="showEndPage">
        您可以等待订单完成或继续浏览其他页面，
            处理完成后订单信息将会自动同步
    </p>


    <div class="status" v-if="orderInfo.trade_status == '2'">
        <img src="../assets/success.png" alt="" width="27%">
        <p>支付成功</p>
    </div>
    <div class="info" v-if="orderInfo.trade_status == '2'">
        <p class="title">
        {{orderInfo.goods_abbreviation}}
        </p>
        <p class="deal_amount">¥<span class="balance">{{orderInfo.amount}}</span></p>
    </div>
    <div class="wrap-btn-foot"  v-if="orderInfo.trade_status == '2'" @click="toRedirect">
        <button  class="btn-md">完成</button>
    </div>


    <div class="status" v-if="orderInfo.trade_status == '3'">
        <img src="../assets/fail.png" alt="" width="27%">
         <p>抱歉，支付失败</p>
    </div>
     <div class="wrap-btn-foot"  v-if="orderInfo.trade_status == '3'"  @click="rePay">
         <button  class="btn-md">重新支付</button>
     </div>

    <div class="wrap-btn-foot"  v-if="showEndPage"  @click="toRedirect">
        <button  class="btn-md">关闭</button>
    </div>
     

</div>
</template>

<script>
import { Checklist } from 'mint-ui';
import { Indicator } from 'mint-ui';
import { Toast } from 'mint-ui';
import {Get,Post} from '@/utils/http';
import { Cell } from 'mint-ui';
export default {
  name: 'PayStatus',
  data () {
    return {
        bill_id:'',
        showEndPage:false,
        payTimer:null,
        countTimer:null,
        redirect: '',
        orderInfo:{
            "wallet_id": "0",     //钱包ID
            "merchant_name": "",   //收款方名称
            "bill_id": "",     //单据ID
            "goods_abbreviation": "",   //商品简称
            "amount": 0,   //单据总金额, 单位分, 退款以负数表示
            "trade_status": "1",    //交易状态, 1:待付款或待退款, 2:支付成功或退款成功, 3: 支付失败或退款失败
            "redirect_url": "",   //业务端回跳地址
             "pay_way": "",   //支付方式, 00: 钱包余额; 01: 快捷支付; 02: 网关; 03: 支付宝; 04:微信
             "trade_time": "",     //交易时间
             "order_type": "" ,  //业务订单类型, 00: 直接支付; 01: 见证支付; 99: 退款
        },
    }
  },
  computed: {
  
  },
  beforeMount(){
      let queryObj = this.$route.query
      if(typeof(queryObj.bill_id)!=='undefined'){
          this.bill_id = queryObj.bill_id;
      }
  },
   mounted() {
       Indicator.open();
       this.payTimer = setInterval(this.getStatus,1500);
       this.countTimer = setTimeout(()=>{
           if(this.orderInfo.trade_status == '1'){
               Indicator.close();
               this.showEndPage = true;
           }
       },10000);
  },
  beforeDestroy() {
    this.payTimer && clearInterval(this.payTimer);
    this.countTimer && clearTimeout(this.countTimer);
  },
   methods: {
    getStatus(){
        const url = '/v1/person/wallet/order_info';
        const params = {
            bill_id:this.bill_id,
        }
        Post(url,params).then((res)=>{
            this.orderInfo = res;
            if(this.orderInfo.trade_status == '2' || this.orderInfo.trade_status == '3'){
                 clearInterval(this.payTimer);
                 this.showEndPage = false;
                 Indicator.close();
            }
        }).catch((error)=>{
            Indicator.close();
            console.log(error);
            // Toast({
            //      message: "code:"+error.code+" message:"+error.msg,
            //      duration: 3000
            // });
        })
    },
    toRedirect(){
         window.location = this.orderInfo.redirect;
    },
    rePay(){
         window.location = window.location.protocol + '//' + window.location.host + '/#/pay?bill_id' + this.bill_id
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.status{
    margin: 0.6rem auto 0.3rem;
    text-align: center;
}
.status p{
    margin-top:10px;
}
.info{
    margin:.2rem;
    text-align: center;
}
.deal_amount{
    margin:0.1rem;
    font-size: .35rem;
}
.wrap-btn-foot{
    margin: .7rem 0 0;
    padding: 0 .15rem;
}
.btn-md {
    -webkit-tap-highlight-color: rgba(255,255,255,0);
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0;
    font-size: 100%;
    font-family: inherit;
    outline-offset: 0;
    outline-style: none;
    outline-width: 0;
    -webkit-font-smoothing: inherit;
    background-image: none;
    text-indent: 0;
    padding-left: 0;
    padding-right: 0;
    border: 0;
    background-color: #3b8aff;
    color: #fff;
    border: none;
    width: 100%;
    height: .44rem;
    line-height: .44rem;
    font-size: 16px;
}
.hint{
    margin: 0.2rem;
    text-align: center;

}
</style>



// WEBPACK FOOTER //
// src/views/PayStatus.vue